import { RoutalAccordion, RoutalAccordionProps } from '@nx-smartmonkey/ui';
import React from 'react';
import { useIntl } from 'react-intl';

interface AccordionProps extends RoutalAccordionProps {
  headerIntl?: string;
  headerIntlValues?: Record<string, string | number>;
}

/**
 * General purpose accordion component. Allows different types and tagNames. An intl-id can be provided to this
 * component.
 * @param props
 */
export const Accordion = (props: React.PropsWithChildren<AccordionProps> & React.DOMAttributes<AccordionProps>) => {
  const { children, headerContent, headerIntl, headerIntlValues } = props;

  const intl = useIntl();
  let processedChildren;

  // Select the content of the class
  if (headerIntl) {
    const message = intl.formatMessage({ id: headerIntl }, headerIntlValues ?? {});
    processedChildren = message;
  } else {
    processedChildren = headerContent;
  }

  return (
    <RoutalAccordion {...props} headerContent={processedChildren}>
      {children}
    </RoutalAccordion>
  );
};
